import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../asets/logo.jpg"; // Adjust path if needed
import './Navbar.css';
import TopBar from "../TopBar";

const Navbar = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem("isLoggedIn") === "true";
  });

  const handleLogout = (e) => {
    e.preventDefault();
    setIsLoggedIn(false);
    localStorage.setItem("isLoggedIn", "false");
    navigate("/login");
  };

  const handleLogin = (e) => {
    e.preventDefault();
    navigate("/login");
  };

  useEffect(() => {
    localStorage.setItem("isLoggedIn", isLoggedIn);
  }, [isLoggedIn]);

  const openPdfInBrowser = (pdfUrl) => {
    const pdfWindow = window.open(pdfUrl, "_blank");
    if (!pdfWindow) {
      alert("Please allow popups for this website to open the document.");
    }
  };

  return (
    <>
      <TopBar />

      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap"
        rel="stylesheet"
      />
      <style>{`
        * {
          font-family: 'Poppins', sans-serif;
        }
        .navbar {
          background: linear-gradient(90deg, #2c3e50, #34495e);
          padding: 0.4rem 1.5rem;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          font-size: 0.9rem;
          letter-spacing: 0.02em;
        }
        .navbar-brand img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          transition: transform 0.25s ease;
          cursor: pointer;
        }
        .navbar-brand img:hover {
          transform: scale(1.05);
        }
        .nav-link {
          color: #ecf0f1 !important;
          font-weight: 500;
          margin-right: 12px;
          padding: 6px 8px;
          border-radius: 4px;
          transition: color 0.25s ease, background-color 0.25s ease;
          cursor: pointer;
        }
        .nav-link:hover {
          color: #f39c12 !important;
          background-color: rgba(243, 156, 18, 0.1);
          transform: scale(1.05);
          text-decoration: none;
        }
        .nav-link.active {
          color: #1abc9c !important;
          font-weight: 600;
          background-color: rgba(26, 188, 156, 0.15);
          border-radius: 5px;
        }
        .dropdown-menu {
          background-color: #34495e;
          border-radius: 8px;
          padding: 8px 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
          border: none;
          min-width: 260px;
          font-size: 0.9rem;
        }
        .dropdown-item {
          color: #ecf0f1;
          padding: 8px 20px;
          transition: background-color 0.3s ease, color 0.3s ease;
          cursor: pointer;
          border-radius: 4px;
        }
        .dropdown-item:hover {
          background-color: #f39c12;
          color: #2c3e50;
          text-decoration: none;
        }
        .dropdown-divider {
          border-top: 1px solid rgba(255, 255, 255, 0.15);
          margin: 6px 0;
        }
        .btn-outline-success {
          border-color: #f39c12;
          color: #f39c12;
          border-radius: 20px;
          padding: 5px 16px;
          font-weight: 600;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          cursor: pointer;
        }
        .btn-outline-success:hover {
          background-color: #f39c12;
          color: #2c3e50;
        }

        /* Submenu styles */
        .dropdown-submenu {
          position: relative;
        }
        .dropdown-submenu:hover .sub-dropdown {
          display: block;
        }
        .sub-dropdown {
          display: none;
          position: absolute;
          top: 0;
          left: 100%;
          background-color: #34495e;
          padding: 8px 0;
          border-radius: 8px;
          min-width: 240px;
          z-index: 1050;
        }
        .sub-dropdown .dropdown-item {
          white-space: nowrap;
        }

        @media (max-width: 768px) {
          .nav-link {
            margin-right: 0;
            padding: 6px 12px;
          }
          .dropdown-item {
            padding: 8px 15px;
          }
          .navbar {
            padding: 0.4rem 1rem;
          }
        }
      `}</style>

      <nav className="navbar navbar-expand-lg navbar-dark">
        <div className="container-fluid">
          <NavLink className="navbar-brand" to="/home" title="Home">
            <img src={logo} alt="Logo" />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item"><NavLink className="nav-link" to="/">Home</NavLink></li>
              <li className="nav-item"><NavLink className="nav-link" to="/about">About</NavLink></li>
              <li className="nav-item"><NavLink className="nav-link" to="/gallery">Gallery</NavLink></li>
              <li className="nav-item"><NavLink className="nav-link" to="/inspiration">Inspiration</NavLink></li>
              <li className="nav-item"><NavLink className="nav-link" to="/tc">TC</NavLink></li>

              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#!" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Mandatory Public Disclosure
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/CBSE Affiliation Extension Letter.pdf")}>CBSE Affiliation Extension Letter</button></li>
                  <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Society Trust Company Registration Certificate.pdf")}>Society Registration Certificate</button></li>
                  <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/NOC.pdf")}>NOC from State Government</button></li>
                  <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/RTE Recognition Certificate Renewal.pdf")}>RTE Recognition Certificate / Renewal</button></li>
                  <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Valid Building Safety Certificate.pdf")}>Valid Building Safety Certificate</button></li>
                  <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Water Health and Sanitation Certificate.pdf")}>Water, Health and Sanitation Certificate</button></li>
                  <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Fire Safety Certificate.pdf")}>Fire Safety Certificate</button></li>
                  <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Self-Certification.pdf")}>Self-Certification</button></li>
                  <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/All Certificate.pdf")}>Mandatory Public Disclosure</button></li>
                  <li><hr className="dropdown-divider" /></li>

                  {/* Submenu for Other Documents */}
                  <li className="dropdown-submenu">
                    <a className="nav-link dropdown-toggle" href="#!" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Other Documents
                </a>
                    <ul className="dropdown-menu sub-dropdown">
                      <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Fee Structure.pdf")}>Fee Structure</button></li>
                      <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Academic Calendar.pdf")}>Annual Academic Calendar</button></li>
                      <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Management Committee.pdf")}>School Management Committee</button></li>
                      <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/PTA.pdf")}>PTA Details</button></li>
                      <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Staff Details.pdf")}>Teaching Staff Details</button></li>
                      <li><button className="dropdown-item" onClick={() => openPdfInBrowser("/Certificate/Results.pdf")}> Last Year Results</button></li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>

            <form className="d-flex">
              {isLoggedIn ? (
                <button className="btn btn-outline-success" onClick={handleLogout}>Logout</button>
              ) : (
                <button className="btn btn-outline-success" onClick={handleLogin}>Login</button>
              )}
            </form>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
